import{diffScores}from"./diffScores";var scoresAreEqual=function(r,e){e=diffScores(r,e);return!(0<Object.keys(e).length)};export{scoresAreEqual};